import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { Checkbox } from '@atlaskit/checkbox';

import { withAnalytics } from 'src/components/settings/analytics';

import { useSingleDiffReviewed } from '../reviewed-files/reviewed-files-provider';
import { KeyboardShortcutTooltip } from '../tabs/shortcuts/keyboard-shortcut-tooltip';
import { keyboardShortcutMessages } from '../tabs/shortcuts/pull-request-keyboard-shortcuts.i18n';

import messages from './reviewed-checkbox.i18n';
import * as styles from './reviewed-checkbox.style';

type ReviewedCheckboxProps = {
  filePath: string;
  onChange: () => void;
};

export const ReviewedCheckbox = withAnalytics(
  ({ filePath, onChange }: ReviewedCheckboxProps) => {
    const isReviewed = useSingleDiffReviewed(filePath);

    return (
      <KeyboardShortcutTooltip
        shortcut="v"
        position="bottom"
        hideTooltipOnMouseDown
        text={
          isReviewed
            ? keyboardShortcutMessages.unmarkFileViewedShortcut
            : keyboardShortcutMessages.markFileViewedShortcut
        }
      >
        <styles.ReviewedCheckboxWrapper
          onClick={event => {
            event.stopPropagation();
          }}
        >
          <Checkbox
            data-testid="reviewed-checkbox"
            isChecked={isReviewed}
            onChange={onChange}
            label={<FormattedMessage {...messages.checkboxLabel} />}
            value="Controlled Checkbox"
            name="controlled-checkbox"
          />
        </styles.ReviewedCheckboxWrapper>
      </KeyboardShortcutTooltip>
    );
  },
  {
    actionSubject: 'checkbox',
    source: 'pullRequestsScreen',
  }
);
